<template>
  <router-link :to="to" class="list-group-item list-group-item-action border border-0" active-class="active">
    <h6><i class="me-1 bi" :class="icon" /> {{ title }}</h6>
  </router-link>
</template>

<script>
export default {
  props: {
    to: { type: String, default: null },
    icon: { type: String, required: true },
    title: { type: String, required: true },
  },
};
</script>
